<template>
  <div>
    <div class="auth">
      <div :class="'auth__box ' + additionalClass">
        <div v-show="displayLogo" class="auth__box-logo">
          <img
            src="../assets/images/logo.svg"
            height="45.139"
            width="183.5"
            alt="Logo ewoods"
          />
        </div>
        <router-view />
      </div>
    </div>
    <div class="logo-ue">
      <img src="../assets/images/logo-ue.png" alt="Logo ewoods" />
    </div>
  </div>
</template>

<script>
export default {
  name: "GuestLayout",
  props: {
    additionalClass: {
      type: String,
      default: "",
    },
    displayLogo: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  setup(props) {},
};
</script>

<style scoped lang="scss">
.logo-ue {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  background: #ffffff;
  height: 70px;
}
::v-deep(.auth) {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url("./../assets/images/VA-background.png");

  background-size: cover;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  padding-bottom: 140px;

  .auth__heading {
    font-size: 3rem;
    line-height: 37px;
    margin-bottom: 30px;
    text-align: center;
    font-weight: 500;
  }

  .auth__text {
    font-size: 2rem;
    line-height: 24px;
    margin-bottom: 25px;

    &--centered {
      text-align: center;
    }
  }

  .auth__url {
    margin-top: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      font-size: 1.8rem;
      line-height: 22px;
      text-align: center;
      font-weight: 500;
    }

    &--brown {
      a {
        color: #9e5d57;
      }
    }
  }

  .auth__box {
    background-color: #f2f2f2;
    border: 1px solid #707070;
    border-radius: 39px;
    padding: 22px 38px 38px;
    max-width: 447px;
    width: 100%;

    &--reset {
      max-width: 696px;
    }

    &--login {
      max-width: 507px;
    }

    &-logo {
      margin: 0 auto 20px;
      text-align: center;
    }
  }

  .auth__buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .auth__prev {
    display: inline-block;
    color: #9e5d57;
    text-transform: uppercase;
    font-weight: 500;
    margin-top: 40px;
  }

  .auth__line {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto;

    &::after {
      content: "";
      width: 100%;
      height: 1px;
      background-color: #8a8a8a;
      position: absolute;
      left: 0;
      top: 7px;
    }

    span {
      position: relative;
      color: #8a8a8a;
      padding: 0 7px;
      z-index: 2;
      background-color: #f2f2f2;
    }
  }

  .auth__remember {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      color: black;
      text-decoration: none;
    }
  }

  .auth__forgotten {
    font-size: 1.5rem;
    margin-top: 15px;

    a {
      font-weight: 500;
      text-decoration: underline;
      color: #000;
    }

    &--again {
      margin-top: 15px;
      font-style: italic;
      color: #9e5d57;
    }
  }

  .auth__error-message {
    margin-bottom: 15px;
    text-align: center;
    color: #9e5d57;
    font-weight: 500;
  }
}
</style>